import { Button } from './ui/button';

import errorBackground from '@/assets/error-page.webp';

export function ErrorPage({ error }: { error: Error }) {
  return (
    <div
      className="relative flex h-screen w-screen justify-center items-center bg-black before:absolute before:inset-0 before:bg-gradient-to-r before:from-black/50 before:via-black/40 before:to-transparent before:z-0"
      style={{
        backgroundImage: `url('${errorBackground}')`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="relative z-10 text-white max-w-2xl font-bold flex flex-col items-center justify-center gap-6 text-center select-text">
        <h1 className="text-4xl">Error</h1>
        <p className="text-2xl">{error.message}</p>
        <a href="/">
          <Button className="bg-amber-600 hover:bg-amber-700 text-white select-none">Go Home</Button>
        </a>
      </div>
    </div>
  );
}
